module.exports = __webpack_public_path__ + "static/media/30_A.94d753a1.png";